import React, { useEffect, useState } from "react";
import { Modal, Button, Tabs, Tab, Table } from "react-bootstrap";
import Axios from "../../../axios/Axios";
import axios from "axios";

export default function ViewSpocBatch(props) {

  const [spocBatchTable, setSpocBatchTable] = useState([]);

  //Get request : To get batch details of spoc
  useEffect(() => {
    const controller = axios.CancelToken.source();

    if(props.spocId){

        (async() => {
            try{
                const response = await Axios("get", `/spoc/teachers/mapped/data/${props.spocId}`, true, null, {cancelToken: controller.token});
                // console.log(response);
                if(response.status === 200){
                    setSpocBatchTable(response.data);
                }
            }catch(error){
              if (!axios.isCancel(error)){
                console.log(error);
              }
            }
        })();
    }
    return () => {
      controller.cancel();
  }
  }, [props.spocId]);
  
  return (
      <Modal
        show={props.show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>
              Spoc Information&nbsp;
            </h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{height:"60vh", overflow:"scroll"}}>
          <Tabs
            className="mb-3"
            id="uncontrolled-tab-example"
            defaultActiveKey="primary"
          >
            <Tab eventKey="primary" title="Mapped Details">
                <div>
                  {spocBatchTable.length > 0 ? 
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Teachers Name</th>
                          <th>Students Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {spocBatchTable.map((data, index) => {
                          return(
                            <tr key={index}>
                              <td><strong>{data.teacher_name}</strong></td>
                              <td>{data.student_name}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table> : 
                    <p style={{display : "flex", justifyContent: "center", color: "red"}}>There is no mapped teachers information for this spoc</p>
                  }
                </div>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
            <div>
              <Button
                type="button"
                variant="light"
                onClick={props.onHide}
              >
                CANCEL
              </Button>
            </div>
        </Modal.Footer>
      </Modal>
    )
}




